import React, { useState, useContext, useEffect } from "react";
import AuthContext from "../../Context/AuthContext";
import { Link, useNavigate, useParams } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { useTranslation } from "react-i18next";
import "./UpdateIndicatorForm.css";

function UpdateIndicatorForm() {
  const [description, setDescription] = useState("");
  const [weight, setWeight] = useState(0);
  const [type, setType] = useState("incremental");
  const [minRange, setMinRange] = useState(0);
  const [maxRange, setMaxRange] = useState(100);
  const [availableWeight, setAvailableWeight] = useState(100);
  const [isLoading, setIsLoading] = useState(true);
  const [show, setShow] = useState(false);

  const navigate = useNavigate();

  const { state } = useContext(AuthContext);

  const { iid } = useParams();

  const { t } = useTranslation();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/indicators/user/update/${iid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setAvailableWeight(response.data.availableWeight);
      setDescription(response.data.indicator.description);
      setWeight(response.data.indicator.weight);
      setType(response.data.indicator.type);
      setMinRange(response.data.indicator.minRange);
      setMaxRange(response.data.indicator.maxRange);

      setIsLoading(false);
    }
    fetch();
  }, [state.token, state.userId, iid]);

  const handleSubmit = async () => {
    try {
      if (validateWeight(weight)) {
        await axios({
          method: "put",
          url: `${process.env.REACT_APP_BACKEND_URL}/indicators/${iid}`,
          data: {
            description: description,
            weight: weight,
            type: type,
            minRange: minRange,
            maxRange: maxRange,
          },
          headers: {
            Authorization: `Bearer ${state.token}`,
          },
        });
        navigate("/myindicators");
      } else {
        handleShow();
      }
    } catch (error) {
      console.log(error.response.data);
    }
  };

  const validateWeight = (weight) => {
    if (weight > availableWeight) {
      return false;
    } else {
      return true;
    }
  };

  const handleDescriptionChange = (evt) => {
    setDescription(evt.target.value);
  };

  const handleWeightChange = (evt) => {
    setWeight(evt.target.value);
  };

  const handleTypeChange = (evt) => {
    setType(evt.target.value);
  };

  const handleMinRangeChange = (evt) => {
    setMinRange(evt.target.value);
  };

  const handleMaxRangeChange = (evt) => {
    setMaxRange(evt.target.value);
  };

  const selectText = (type) => {
    switch (type) {
      case "incremental":
        return (
          <Form.Text className="text-muted">
            {t("Indicadores.EditForm.IncrementalTexto")}
          </Form.Text>
        );
      case "decremental":
        return (
          <Form.Text className="text-muted">
            {t("Indicadores.EditForm.DecrementalTexto")}
          </Form.Text>
        );
      case "completive":
        return (
          <Form.Text className="text-muted">
            {t("Indicadores.EditForm.CompletiveTexto")}
          </Form.Text>
        );
      default:
        return (
          <Form.Text className="text-muted">
            {t("Indicadores.EditForm.IncrementalTexto")}
          </Form.Text>
        );
    }
  };

  if (isLoading === true) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Container fluid>
        <Row>
          <Col className="new-indicator-header">
            <h2>{t("Indicadores.EditForm.Titulo")}</h2>
          </Col>
        </Row>
        <Row>
          <Col className="new-indicator-form">
            <Col className="availble-weight">
              <h5>
                {t("Indicadores.EditForm.PonderacionDisponible")}:{" "}
                {availableWeight}
              </h5>
            </Col>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>
                  {t("Indicadores.EditForm.TipoIndicador")}
                </Form.Label>
                <Form.Select
                  aria-label="Tipo de indicador"
                  onChange={handleTypeChange}
                  value={type}
                  className="mb-1"
                >
                  <option value="incremental">
                    {t("Indicadores.EditForm.Incremental")}
                  </option>
                  <option value="decremental">
                    {t("Indicadores.EditForm.Decremental")}
                  </option>
                  <option value="completive">
                    {t("Indicadores.EditForm.Completive")}
                  </option>
                </Form.Select>
                {selectText(type)}
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>{t("Indicadores.EditForm.Descripcion")}</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder={t("Indicadores.EditForm.PlaceholderDescripcion")}
                  onChange={handleDescriptionChange}
                  value={description}
                />
              </Form.Group>
              {type !== "completive" ? (
                <Row>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        {t("Indicadores.EditForm.ValorMinimo")}
                      </Form.Label>
                      <Form.Control
                        type="number"
                        onChange={handleMinRangeChange}
                        value={minRange}
                      />
                      <Form.Text className="text-muted">
                        {t("Indicadores.EditForm.ValorMinimoTexto")}
                      </Form.Text>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        {t("Indicadores.EditForm.ValorMaximo")}
                      </Form.Label>
                      <Form.Control
                        type="number"
                        onChange={handleMaxRangeChange}
                        value={maxRange}
                      />
                      <Form.Text className="text-muted">
                        {t("Indicadores.EditForm.ValorMaximoTexto")}
                      </Form.Text>
                    </Form.Group>
                  </Col>
                </Row>
              ) : (
                <></>
              )}

              <Form.Group className="mb-3">
                <Form.Label>{t("Indicadores.EditForm.Ponderacion")}</Form.Label>
                <Row className="justify-content-center align-items-center">
                  <Col lg={11}>
                    <Form.Range
                      defaultValue={weight}
                      name="weight"
                      onChange={(e) => handleWeightChange(e)}
                    />
                  </Col>
                  <Col lg={1}>
                    <span className="weightVal">{weight}</span>
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group className="mb-3">
                <Button className="primary" onClick={handleSubmit}>
                  {t("Indicadores.EditForm.Guardar")}
                </Button>
                <Link to="/indicators">
                  <Button className="danger">
                    {t("Indicadores.EditForm.Cancelar")}
                  </Button>
                </Link>
              </Form.Group>
            </Form>
          </Col>
        </Row>
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>
              {t("Indicadores.EditForm.PonderacionExcedidaTitulo")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>{t("Indicadores.EditForm.PonderacionExcede")}</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              {t("Indicadores.EditForm.Cerrar")}
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    );
  }
}

export default UpdateIndicatorForm;
